import { render } from "./AppleButton.vue?vue&type=template&id=c7ce1e9e"
const script = {}
script.render = render

export default script